import React, { ReactElement } from "react";
import { Global, css } from "@emotion/react";

export const TagInputCssOverrides = (): ReactElement => {
  /**
   * CSS override description:
   * - New proposal styles for tag-input
   */

  return (
    <Global
      styles={css`
        /* Input */
        .spark-tag-input__container {
          min-height: 5rem;
          height: auto; /* field should vertically expand */
          background-color: #f6f6f7;
          border: 1px solid #6d7178;
          color: #404247;
          font-family: Roboto, sans-serif;
          font-weight: 400;
          -webkit-transition: background-color 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            border 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            -webkit-box-shadow 0.2s cubic-bezier(0, 0.4, 0.4, 1);
          transition: background-color 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            border 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            -webkit-box-shadow 0.2s cubic-bezier(0, 0.4, 0.4, 1);
          transition: background-color 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            border 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            box-shadow 0.2s cubic-bezier(0, 0.4, 0.4, 1);
          transition: background-color 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            border 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            box-shadow 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            -webkit-box-shadow 0.2s cubic-bezier(0, 0.4, 0.4, 1);
          -webkit-box-shadow: none;
          box-shadow: none;
          position: relative;
          border-radius: 1rem;
          cursor: pointer;
          display: block;
          line-height: 2.1rem;
          -webkit-transition: background-color 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            border 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            border-radius 0.2s cubic-bezier(0, 0.4, 0.4, 1);
          transition: background-color 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            border 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            border-radius 0.2s cubic-bezier(0, 0.4, 0.4, 1);
          width: 100%;
          font-size: 1.3333333333rem;
          z-index: 10;
        }

        .spark-tag-input__container .spark-label {
          cursor: inherit;
          pointer-events: none;
          display: block;
          z-index: 10;
          font-weight: inherit;
          left: 1rem;
          margin: 0 1px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: calc(100% - 2rem);
          color: #54575d;
          line-height: 2rem;
          position: absolute;
          top: 1.5rem;
          -webkit-transition: font-size 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            color 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            top 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            line-height 0.2s cubic-bezier(0, 0.4, 0.4, 1);
          transition: font-size 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            color 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            top 0.2s cubic-bezier(0, 0.4, 0.4, 1),
            line-height 0.2s cubic-bezier(0, 0.4, 0.4, 1);
          font-size: inherit;
        }

        .spark-tag-input__container.focus {
          -webkit-box-shadow: 0 0 0 3px #309ab5;
          box-shadow: 0 0 0 3px #309ab5;
          border: 1px solid transparent;
          background-color: #fff;
          outline: 0;
        }

        .spark-tag-input__container.active .spark-label,
        .spark-tag-input__container.focus .spark-label {
          top: 0.5rem;
          font-size: 1.0833333333rem;
        }

        .spark-tag-input__container.active .spark-label,
        .spark-tag-input__container.focus .spark-label {
          font-size: 1.3333333333rem;
        }

        .spark-tag-input__container.focus .spark-label {
          color: #007b94;
        }

        /* only when input is focus, expand <input> beyond its min-width, to accomodate long placeholder text */
        .spark-tag-input__container.focus .spark-tag-input__tags li:last-child {
          width: 100%;
        }

        .spark-tag-input__container.focus .spark-tag-input__tag {
          background-color: #e9f9ff;
          border-color: #309ab5;
        }

        /* component status styling */
        .spark-tag-input[data-error]
          .spark-tag-input__container.focus
          .spark-tag-input__input {
          background: #ffffff;
        }
        .spark-tag-input[data-error] .spark-label,
        .spark-tag-input[data-error]
          .spark-tag-input__container
          .spark-tag-input__tag[data-error]
          .spark-tag-input__tag__label,
        .spark-tag-input[data-error] .spark-input__message,
        .spark-tag-input[data-error]
          .spark-tag-input__container
          .spark-tag-input__tag[data-error]
          .spark-btn--icon.spark-icon {
          color: #d13630;
        }
        .spark-tag-input[data-error] .spark-tag-input__container,
        .spark-tag-input[data-error] .spark-tag-input__tag[data-error] {
          border-color: #d13630;
        }
        .spark-tag-input[data-error] .spark-tag-input__container.focus {
          box-shadow: 0 0 0 3px #d13630;
          border-color: transparent;
        }
        .spark-tag-input[data-error] .spark-tag-input__input {
          background-color: #fff4f1;
        }

        .spark-tag-input[data-error]
          .spark-tag-input__container.focus
          .spark-tag-input__tag[data-error] {
          background-color: #ffffff;
        }

        .spark-tag-input[data-error]
          .spark-tag-input__tag[data-error]
          .spark-btn--icon.spark-icon:focus,
        .spark-tag-input[data-error]
          .spark-tag-input__tag[data-error]
          .spark-btn--icon.spark-icon:active,
        .spark-tag-input[data-error]
          .spark-tag-input__tag[data-error]
          .spark-btn--icon.spark-icon:focus:active:hover {
          box-shadow: 0 0 0 1px #d13630;
        }

        .spark-tag-input[data-error]
          .spark-tag-input__tag[data-error]
          .spark-btn--icon.spark-icon:active,
        .spark-tag-input[data-error]
          .spark-tag-input__tag[data-error]
          .spark-btn--icon.spark-icon:focus,
        .spark-tag-input[data-error]
          .spark-tag-input__tag[data-error].spark-btn--icon.spark-icon:active:focus {
          background-color: #d13630;
          color: #ffffff;
        }

        .spark-tag-input[data-error] .spark-input__message,
        .spark-tag-input[data-info] .spark-input__message,
        .spark-tag-input[data-warning] .spark-input__message,
        .spark-tag-input[data-success] .spark-input__message {
          background-color: transparent;
        }

        .spark-tag-input[data-error] .spark-tag-input__input,
        .spark-tag-input[data-info] .spark-tag-input__input,
        .spark-tag-input[data-warning] .spark-tag-input__input,
        .spark-tag-input[data-success] .spark-tag-input__input {
          border-radius: 1rem;
        }
        .spark-tag-input[data-error] .spark-input__message,
        .spark-tag-input[data-info] .spark-input__message,
        .spark-tag-input[data-warning] .spark-input__message,
        .spark-tag-input[data-success] .spark-input__message {
          display: block;
        }

        /* Wrapper of input and tags */
        .spark-tag-input__input {
          padding: 2.25rem 1rem 0.5rem;
          display: flex;
          flex-wrap: wrap;
          -webkit-box-align: center;
          align-items: center;
          font-size: inherit;
        }

        .spark-tag-input__tags {
          margin: 0;
        }
        /* inline last li > input next to other li */
        .spark-tag-input__tags li:last-child {
          margin: 0;
          list-style-type: none;
          display: inline-flex;
        }

        .spark-tag-input__tag {
          list-style-type: none;
          background-color: #ffffff;
          border: 2px solid #404247;
          padding: 0;
          margin: 0 0.3rem 0 0;
          border-radius: 1.5rem;
          font-size: 1.3333333333rem;
          line-height: 1;
          display: inline-block;
          pointer-events: none; /* keyboard focus only */
        }

        .spark-tag-input__tag.focus {
          background-color: #e1e2e5;
        }

        li.spark-tag-input__tag:focus {
          outline: #404247 !important;
        }

        .spark-tag-input__tag:first-of-type {
          margin-left: 0;
        }

        li.spark-tag-input__tag:last-of-type {
          margin-right: 0.5rem;
        }

        .spark-input--tag-input {
          background-color: transparent;
          border-color: transparent;
          outline: 0;
          width: 100%;
          border: 0;
          cursor: inherit;
          -webkit-box-flex: 1;
          -webkit-flex-grow: 1;
          -ms-flex-positive: 1;
          flex-grow: 1;
          line-height: 1.375;
          min-width: 30px;
          font-size: 1.3333333333rem;
          font-weight: 700;
          padding: 0.125rem 0;
        }

        // hide input on blur
        .spark-tag-input__container.hide
          .spark-input--tag-input:not(:focus):not(:active) {
          clip: rect(0 0 0 0);
          clip-path: inset(50%);
          height: 1px;
          overflow: hidden;
          position: absolute;
          white-space: nowrap;
          width: 1px;
        }

        input.spark-input--tag-input::placeholder {
          font-weight: 400;
        }

        /* Pill/Tag Close Icon */
        .spark-tag-input__container.focus .spark-btn--icon.spark-icon {
          color: #007b94;
        }

        .spark-tag-input__container.focus .spark-btn--icon.spark-icon:focus {
          box-shadow: 0 0 0 1px #309ab5;
          border: 1px solid transparent;
          color: #ffffff;
        }

        .spark-tag-input__container.active .spark-btn--icon.spark-icon:hover {
          border: 1px solid transparent;
        }

        .spark-tag-input__container.active .spark-btn--icon.spark-icon:active,
        .spark-btn--icon.spark-icon:active:focus,
        .spark-btn--icon.spark-icon:active:hover:focus {
          border: 1px solid transparent;
        }

        .spark-tag-input__container.focus .spark-tag-input__tag__label {
          color: #309ab5;
        }

        .spark-tag-input__container .spark-btn--icon.spark-icon:focus {
          box-shadow: 0 0 0 1px #404247;
          border: 1px solid transparent;
        }

        .spark-tag-input__container .spark-btn--icon.spark-icon:hover:focus {
          box-shadow: 0 0 0 1px #404247;
        }

        .spark-tag-input__container .spark-btn--icon.spark-icon:active {
          box-shadow: 0 0 0 1px #404247;
          background-color: #404247;
          border: 1px solid transparent;
        }

        .spark-tag-input__container.focus
          .spark-btn--icon.spark-icon:active:hover,
        .spark-tag-input__container.focus
          .spark-btn--icon.spark-icon:active:focus,
        .spark-tag-input__container.focus
          .spark-btn--icon.spark-icon:active:hover:focus,
        .spark-tag-input__container.focus .spark-btn--icon.spark-icon:active,
        .spark-tag-input__container.focus
          .spark-btn--icon.spark-icon:hover:focus {
          box-shadow: 0 0 0 1px #309ab5;
          background-color: #309ab5;
          color: #ffffff;
        }

        .spark-tag-input__container .spark-btn--icon.spark-icon:active:hover,
        .spark-tag-input__container .spark-btn--icon.spark-icon:active:focus,
        .spark-tag-input__container
          .spark-btn--icon.spark-icon:active:hover:focus {
          box-shadow: 0 0 0 1px #404247;
          background-color: #404247;
        }

        .spark-tag-input__container .spark-btn--icon.spark-icon {
          font-size: 0.6rem;
          padding: 1px;
          border: 1px solid transparent;
          cursor: pointer;
          pointer-events: all;
          line-height: 1;
          margin: 4px 4px 4px 5px;
          text-align: center;
          width: auto;
          color: #404247;
        }
        .spark-tag-input__container .spark-icon::before {
          font-weight: 700;
        }

        .spark-tag-input__tag__label {
          padding: 0 0 0 0.8rem;
          color: #404247;
          vertical-align: middle;
        }

        .spark-auto-suggest__list-item.active {
          background-color: #f6f6f7;
        }

        .spark-listbox-item {
          display: flex;
        }

        .spark-listbox-item__icon {
          vertical-align: middle;
          width: 2rem;
          height: 2rem;

          .spark-icon {
            color: #121315;
          }
        }
      `}
    />
  );
};
